<mat-expansion-panel class="mb-3" [formGroup]="form">
  <mat-expansion-panel-header>
    <mat-panel-title>Historik</mat-panel-title>
  </mat-expansion-panel-header>
  <div fxLayout="column" fxLayoutGap="5px">
    <mat-form-field class="select-digest">
      <mat-label>Digest type</mat-label>
      <mat-select formControlName="digest">
        @for (digest of applicantDigests; track digest) {
          <mat-option
            [value]="digest"
          >{{'grant-admin.history-settings.digest.select.' + digest | translate}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle ngDefaultControl
      formControlName="force_digest"
    >Tving digest</mat-slide-toggle>
    <mat-slide-toggle ngDefaultControl
      formControlName="production_unit_on_top"
    >Vis P-nummer historik over CVR-nummer historik</mat-slide-toggle>
  </div>
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
